import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=e6431a06&scoped=true&"
import script from "./AuthSidebar.vue?vue&type=script&lang=ts&"
export * from "./AuthSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSidebar.vue?vue&type=style&index=0&id=e6431a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6431a06",
  null
  
)

export default component.exports